const TributeWall = () => {
    if (document.body.classList.contains('block-editor-page')) {
        return;
    }

    const grid = document.querySelector('.tribute-wall__wrap--items');

    if (!grid) {
        return;
    }

    // Keep normal grid layout inside Gutenberg editor.
    if (grid.classList.contains('is-editor')) {
        return;
    }

    const GAP = 20;

    const getPostsPerPage = () => {
        return window.innerWidth < 768 ? 6 : 12;
    };

    const getVisibleCards = grid => {
        return [...grid.querySelectorAll('.tribute-card')].filter(
            card => card.style.display !== 'none'
        );
    };

    const updateVisibleCards = (grid, visibleCount) => {
        const cards = [...grid.querySelectorAll('.tribute-card')];

        cards.forEach((card, index) => {
            card.style.display = index < visibleCount ? '' : 'none';
        });
    };

    const observeImages = grid => {
        grid.querySelectorAll('img').forEach(img => {
            if (!img.complete) {
                img.addEventListener('load', () => layoutTributes(grid), { once: true });
            }
        });
    };

    const layoutTributes = grid => {
        const cards = getVisibleCards(grid);

        if (!cards.length) {
            grid.style.height = '0px';
            return;
        }

        const width = grid.clientWidth;

        let columns = 1;

        if (width >= 1400) {
            columns = 5;
        } else if (width >= 1024) {
            columns = 4;
        } else if (width >= 768) {
            columns = 3;
        } else if (width >= 500) {
            columns = 2;
        }

        const cardWidth = (width - GAP * (columns - 1)) / columns;
        const columnHeights = new Array(columns).fill(0);

        cards.forEach((card, index) => {
            card.style.width = `${cardWidth}px`;

            const column =
                index < columns ? index : columnHeights.indexOf(Math.min(...columnHeights));

            const x = column * (cardWidth + GAP);
            const y = columnHeights[column];

            /*
             * Store the Masonry position as CSS variables so that
             * the card animation can use the same values.
             */
            card.style.setProperty('--tribute-card-x', `${x}px`);

            card.style.setProperty('--tribute-card-y', `${y}px`);

            card.style.transform = `
                translate3d(
                    var(--tribute-card-x),
                    var(--tribute-card-y),
                    0
                )
            `;

            columnHeights[column] = y + card.offsetHeight + GAP;
        });

        grid.style.height = `${Math.max(...columnHeights) - GAP}px`;
    };

    /*
     * The initial PHP query loads 12 posts.
     *
     * Desktop:
     * - Show all 12.
     *
     * Mobile:
     * - Show only 6.
     */
    let visibleCount = Math.min(getPostsPerPage(), grid.querySelectorAll('.tribute-card').length);

    updateVisibleCards(grid, visibleCount);
    layoutTributes(grid);
    observeImages(grid);

    // Catches late-loading fonts/images that shift card heights.
    window.addEventListener('load', () => {
        layoutTributes(grid);
    });

    let resizeFrame;

    window.addEventListener('resize', () => {
        cancelAnimationFrame(resizeFrame);

        resizeFrame = requestAnimationFrame(() => {
            layoutTributes(grid);
        });
    });

    const button = document.querySelector('.tribute-wall__load-more');

    if (button) {
        const ajaxUrl = grid.dataset.ajaxUrl;

        button.addEventListener('click', () => {
            button.disabled = true;

            const page = parseInt(grid.dataset.page, 10) + 1;

            const max = parseInt(grid.dataset.maxPages, 10);

            const postsPerPage = getPostsPerPage();

            const allCards = [...grid.querySelectorAll('.tribute-card')];

            /*
             * If there are already loaded but hidden cards,
             * reveal the next batch before making another
             * AJAX request.
             */
            if (allCards.length > visibleCount) {
                const previousVisibleCount = visibleCount;

                visibleCount = Math.min(visibleCount + postsPerPage, allCards.length);

                const newlyVisibleCards = allCards.slice(previousVisibleCount, visibleCount);

                newlyVisibleCards.forEach(card => {
                    card.classList.add('is-loading');
                });

                updateVisibleCards(grid, visibleCount);

                requestAnimationFrame(() => {
                    layoutTributes(grid);
                    observeImages(grid);

                    requestAnimationFrame(() => {
                        newlyVisibleCards.forEach(card => {
                            card.classList.remove('is-loading');
                        });
                    });
                });

                button.disabled = false;

                return;
            }

            /*
             * No hidden cards remain, so fetch the next page.
             *
             * Always request 12 from PHP so that WordPress
             * pagination remains consistent.
             */
            const formData = new FormData();

            formData.append('action', 'load_more_tributes');

            formData.append('page', page);

            formData.append('category', grid.dataset.category);

            formData.append('posts_per_page', 12);

            fetch(ajaxUrl, {
                method: 'POST',
                body: formData,
            })
                .then(res => res.json())
                .then(response => {
                    if (!response.success || !response.data.html) {
                        return;
                    }

                    const previousCardCount = grid.querySelectorAll('.tribute-card').length;

                    grid.insertAdjacentHTML('beforeend', response.data.html);

                    const allCards = [...grid.querySelectorAll('.tribute-card')];

                    const newCards = allCards.slice(previousCardCount);

                    /*
                     * Mark newly loaded cards before laying
                     * them out so they can animate into place.
                     */
                    newCards.forEach(card => {
                        card.classList.add('is-loading');
                    });

                    /*
                     * Show the next batch.
                     *
                     * Mobile = 6
                     * Desktop = 12
                     */
                    visibleCount = Math.min(previousCardCount + postsPerPage, allCards.length);

                    updateVisibleCards(grid, visibleCount);

                    requestAnimationFrame(() => {
                        layoutTributes(grid);
                        observeImages(grid);

                        /*
                         * Wait another frame so the browser
                         * registers the initial state before
                         * removing the animation class.
                         */
                        requestAnimationFrame(() => {
                            newCards.forEach(card => {
                                card.classList.remove('is-loading');
                            });
                        });
                    });

                    grid.dataset.page = page;

                    /*
                     * Only remove the button once the final
                     * WordPress page has been loaded.
                     */
                    if (page >= max) {
                        button.remove();
                    }
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    if (button.isConnected) {
                        button.disabled = false;
                    }
                });
        });
    }
};

export default TributeWall;
